import React from 'react'

import { HomeIndex } from 'app/Home'

interface HomePage {
  title?: string
}

const HomePage = ({}: HomePage) => {
  return <HomeIndex />
}

// eslint-disable-next-line react/display-name
// HomePage.Layout = Layout
HomePage.layoutOpts = {
  hasHeader: true,
  hasSidebar: true,
  className: 'h-[80vh]',
  activeSidebarKey: 'home',
}

export default HomePage
